import React, { useRef, useEffect } from "react";
import { StatusIcon } from "../../../assets/svg/StatusIcon";
import { Formik, Field } from "formik";
import Form, { InputSection } from "../components/Form";
import { DropDown } from "../../../ui/DropDown";
import Input from "../../../ui/Input";
import { TitleText } from "../../../ui/Text";
import FileUploader from "../../../ui/FileUploader";
import { GetHook, postEndpoint, putEndpoint } from "../../../api/api";
import {
  USER_URL,
  ROLE_URL,
  ORGANISATION_URL,
  COMPANY_URL,
} from "../../../api/urls";
import { parseDropdown } from "../../../utils/parseDropdown";
import { get } from "../../../utils/get";
import { toast } from "react-toastify";
import { UserSchema } from "../../../utils/validationSchema/UserSchema";
import { convertJsonToFormData } from "../../../utils/Json2formData";
interface IProps {
  setHandleSubmit?: any;
  closeModal: any;
  editData?: any;
  users?: any;
  setUsers?: any;
}
const AddPersonForm = ({
  setHandleSubmit,
  editData,
  closeModal,
  users,
  setUsers,
}: IProps) => {
  const formRef: any = useRef<any>(null);
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();

  const { id } = editData;

  const isAddMode = !id;

  const { data: roles } = GetHook(ROLE_URL);
  const { data: organisations } = GetHook(ORGANISATION_URL);
  const { data: companies } = GetHook(COMPANY_URL);

  const roleOptions = parseDropdown(roles);
  const organisationOptions = parseDropdown(organisations);
  const companyOptions = parseDropdown(companies);

  useEffect(() => {
    if (!isAddMode) {
      const newEditData = {
        ...editData,
        role: {
          value: get(editData, "role.id"),
          label: get(editData, "role.name"),
        },
        organisation: {
          value: get(editData, "organisation.id"),
          label: get(editData, "organisation.name"),
        },
        pay_grade: {
          value: get(editData, "pay_grade"),
          label: get(editData, "pay_grade"),
        },
        company: {
          value: get(editData, "company_id"),
          label: get(editData, "company.name"),
        },
        status: {
          value: get(editData, "active") ? "Active" : "Non Active",
          label: get(editData, "active") ? "Active" : "Non Active",
        },
      };
      const fields = [
        "first_name",
        "last_name",
        "email",
        "notes",
        "role",
        "organisation",
        "hourly_rate",
        "billing_rate",
        "staff_number",
        "job_title",
        "pay_grade",
        "status",
        "company",
      ];
      fields.forEach((field) =>
        formRef.current.setFieldValue(field, newEditData[field], false)
      );
    }
  }, []);

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, [setHandleSubmit]);

  const addUser = (values) => {
    const payload: any = {
      first_name: get(values, "first_name", ""),
      last_name: get(values, "last_name", ""),
      email: get(values, "email", ""),
      job_title: get(values, "job_title", ""),
      staff_number: get(values, "staff_number", ""),
      organisation_id: get(values, "organisation.value", ""),
      active: get(values, "status.value") === "Active" ? true : false,
      role_id: get(values, "role.value", ""),
      pay_grade: get(values, "pay_grade.value", ""),
      company_id: get(values, "company.value", ""),
      password: "123456",
    };
    if (get(values, "avatar")) {
      payload.avatar = get(values, "avatar");
    }
    if (get(values, "hourly_rate")) {
      payload.hourly_rate = get(values, "hourly_rate", "");
    }
    if (get(values, "billing_rate")) {
      payload.billing_rate = get(values, "billing_rate", "");
    }
    const formData = convertJsonToFormData(payload);

    createReq(USER_URL, formData);
  };

  const editUser = (values) => {
    console.log(values);

    const payload: any = {
      first_name: get(values, "first_name"),
      last_name: get(values, "last_name"),
      email: get(values, "email"),
      job_title: get(values, "job_title"),
      staff_number: get(values, "staff_number"),
      organisation_id: get(values, "organisation.value"),
      hourly_rate: get(values, "hourly_rate"),
      billing_rate: get(values, "billing_rate"),
      active: get(values, "status.value") === "Active" ? true : false,
      role_id: get(values, "role.value"),
      pay_grade: get(values, "pay_grade.value"),
      company_id: get(values, "company.value"),
    };

    if (get(values, "avatar")) {
      payload.avatar = get(values, "avatar");
    }
    const formData = convertJsonToFormData(payload);
    console.log(formData);

    updateReq(`${USER_URL}/${id}`, formData);
  };

  useEffect(() => {
    const { complete, pending, data, error } = createRes;
    if (error) {
      toast.error("Failed! Try again");
    }
    if (!pending && complete && !error) {
      closeModal();
      toast.success("User added successfully");
    }

    return () => {};
  }, [createRes]);

  useEffect(() => {
    const { complete, pending, data } = updateRes;
    if (!pending && complete && data) {
      closeModal();
    }
  }, [closeModal, users, updateRes]);

  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    job_title: "",
    staff_number: "",
    organisation: "",
    hourly_rate: "",
    billing_rate: "",
    avatar: "",
    status: "",
    pay_grade: "",
    role: "",
    company: "",
  };
  const options = [
    { value: "Active", label: "Active" },
    { value: "Non-Active", label: "Non-Active" },
  ];
  const gradeOptions = [
    { value: "level1", label: "Level 1" },
    { value: "level2", label: "Level 2" },
    { value: "level3", label: "Level 3" },
    { value: "level4", label: "Level 4" },
    { value: "level5", label: "Level 5" },
    { value: "level6", label: "Level 6" },
    { value: "level7", label: "Level 7" },
    { value: "level8", label: "Level 8" },
    { value: "level9", label: "Level 9" },
    { value: "level10", label: "Level 10" },
  ];
  return (
    <Formik
      initialValues={initialValues}
      innerRef={formRef}
      validationSchema={UserSchema}
      onSubmit={
        isAddMode ? (values) => addUser(values) : (values) => editUser(values)
      }
    >
      {({ values }) => (
        <Form>
          <InputSection>
            <TitleText>Basic information</TitleText>
          </InputSection>
          <Field
            type="text"
            name="first_name"
            placeholder="First name"
            label="First name"
            width="87%"
            component={Input}
          />
          <Field
            type="text"
            name="last_name"
            placeholder="Last name"
            label="Last name"
            width="87%"
            component={Input}
          />
          <Field
            type="email"
            name="email"
            placeholder="email"
            label="Email"
            width="87%"
            component={Input}
          />
          <Field
            type="text"
            name="job_title"
            placeholder="Job title"
            label="Job title"
            width="87%"
            component={Input}
          />
          <Field
            type="text"
            name="pay_grade"
            placeholder="Job title"
            dropdownLabel="Grade"
            width="18rem"
            options={gradeOptions}
            component={DropDown}
            backgroundColor="#F5F6FB"
          />
          <Field
            type="text"
            name="staff_number"
            placeholder="400"
            label="Staff number"
            width="87%"
            component={Input}
          />

          <Field
            name="company"
            dropdownLabel="Company"
            component={DropDown}
            options={companyOptions}
            width="18rem"
            backgroundColor="#F5F6FB"
          />

          <Field
            name="organisation"
            dropdownLabel="Organization"
            component={DropDown}
            options={
              get(values, "company")
                ? parseDropdown(
                    organisations.filter(
                      (org) => org.company_id === get(values, "company.value")
                    )
                  )
                : organisationOptions
            }
            width="18rem"
            backgroundColor="#F5F6FB"
          />

          <InputSection>
            <TitleText>Cost and Billing Rates</TitleText>
          </InputSection>
          <Field
            type="text"
            name="hourly_rate"
            placeholder="400"
            label="Hourly Rate(KES)"
            width="87%"
            component={Input}
          />
          <Field
            type="text"
            name="billing_rate"
            placeholder="400"
            label="Billing Rate(KES)"
            width="87%"
            component={Input}
          />
          <InputSection>
            <TitleText>Account settings</TitleText>
          </InputSection>
          <Field
            name="role"
            dropdownLabel="Platform role"
            component={DropDown}
            options={roleOptions}
            width="18rem"
            backgroundColor="#F5F6FB"
          />

          <Field
            name="status"
            dropdownLabel="Account status"
            component={DropDown}
            options={options}
            width="18rem"
            backgroundColor="#F5F6FB"
          />

          <InputSection>
            <Field
              name="avatar"
              component={FileUploader}
              label="Avatar"
              backgroundColor="#F5F6FB"
            />
          </InputSection>
        </Form>
      )}
    </Formik>
  );
};

export default AddPersonForm;
